import { Injectable } from '@angular/core';
import { ApiClientService } from 'src/app/@core/services/api-client.service';
import { BaseFucntionsService } from 'src/app/@core/services/base-functions.service';
import { Observable } from 'rxjs';
import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';
import { HomeImageModel } from '../models/home-image.model';
import { HomeImageType } from '../enums/home-image-type.enum';

@Injectable({
  providedIn: 'root',
})
export class HomeImageService extends BaseFucntionsService<HomeImageModel> {
  constructor(apiClient: ApiClientService) {
    super(ApplicationRoutes.HomeImage.HomeImages, apiClient);
  }

  GetMainBannerImages() {
    let type = HomeImageType.MainBanner;
    return this.apiClient.get(
      `${ApplicationRoutes.HomeImage.HomeImages}?type=${type}`
    );
  }

  GetMiddleBannerImages() {
    let type = HomeImageType.Banner;
    return this.apiClient.get(
      `${ApplicationRoutes.HomeImage.HomeImages}?type=${type}`
    );
  }

  GetSections() {
    return this.apiClient.get(`${ApplicationRoutes.HomeSection.Sections}`);
  }
}
